import { Injectable } from '@angular/core';

import { _CentralPageService } from './_central-page.service';

@Injectable()
export class SinglePageService extends _CentralPageService
{
    override readonly pageMode$$ = this._pageMode$$.asReadonly();
    override readonly pageMode_initial$$ = this._pageMode_initial$$.asReadonly();
    override readonly pageMode_prev$$ = this._pageMode_prev$$.asReadonly();
    override readonly btnCancelData$$ = this._btnCancelData$$;
    override readonly btnDeleteData$$ = this._btnDeleteData$$;
    override readonly btnEditData$$ = this._btnEditData$$;
    override readonly btnSaveData$$ = this._btnSaveData$$;
    override readonly onCancelEmit$ = this._onCancelEmit$.asObservable();
    override readonly onDeleteEmit$ = this._onDeleteEmit$.asObservable();
    override readonly onEditEmit$ = this._onEditEmit$.asObservable();
    override readonly onSaveEmit$ = this._onSaveEmit$.asObservable();
    override readonly pageName_sectionDetails$$ = this._pageName_sectionDetails$$.asReadonly();
    override readonly pageName_sectionEdit$$ = this._pageName_sectionEdit$$.asReadonly();
    override readonly template_sectionDetails$$ = this._template_sectionDetails$$.asReadonly();
    override readonly template_sectionEdit$$ = this._template_sectionEdit$$.asReadonly();
    override readonly sectionDetails_buttons_template$$ = this._sectionDetails_buttons_template$$.asReadonly();
    override readonly sectionEdit_buttons_template$$ = this._sectionEdit_buttons_template$$.asReadonly();
    override readonly sectionDetails_extraButtons_template$$ = this._sectionDetails_extraButtons_template$$.asReadonly();
    override readonly sectionEdit_extraButtons_template$$ = this._sectionEdit_extraButtons_template$$.asReadonly();
    override readonly pageLayout$$ = this._pageLayout$$.asReadonly();
    override readonly sectionDetails_show$$ = this._sectionDetails_show$$;
    override readonly tabVisible$$ = this._tabVisible$$;
    override readonly hasEditSection$$ = this._hasEditSection$$;
}
